// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__rNoGS","choiceBoxes":"toolbarselects_choiceBoxes__3AIBJ","simpleField":"toolbarselects_simpleField__3bMLJ"};